var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    viewBox: "0 0 155 155",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4620AE",
    d: "M53.2 31.6l6.6 7.7 5-3.5-6.6-8zM27.5 114.7c0-9.5-2.4-35.5 24.5-35.5h46.2l-.6 42.1-70.1-6.6z",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1 37.8c9.6-7 34.8 1 35.2 1.3l14.5 15.1c1.4 1.6.8 5.6-2.8 5.4h-5.6c-.9 0-1.7.8-1.7 2.7 0 11.6-2.7 22.9-9.4 23.6-25.6 2.9-23-6.7-40.1-6.7 0 0 .3-3.5-1-7.1-.2-.3-4.4-23.3 11-34.3",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4 69.1c.4-1.3 1-7.4 1.5-10.4.4-3-1.9-3.4-3.7-3.8-1.7-.3-6.8-1.6-6-8 .6-6.5 8.3-7.8 13.7-7.8h19.4l-1.1-1.2c-9.7-10-26.9-7.6-36.5-.7-15.3 11-10.7 30-9 34 .2.2.3.6.4.9h17.1c2.7 0 4-1.7 4.2-3",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6 50.6l4.1-7.2 1.5-.2c7.3-.3 8.8 4.8 8.7 7 0 4.5-4.1 7.3-8.6 7.1l-2.1-.3s-1.8-4.3-3.6-6.4",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 68.7l-2.4-.3a10 10 0 0 1-6.6-5.7 1 1 0 0 1 1.8-.8c1 2.2 3 3.9 5.3 4.5a7 7 0 0 0 6-1 1 1 0 0 1 1.3 1.6 8.8 8.8 0 0 1-5.3 1.7M87.7 43.4c-6.4 1.1-10 7.3-10 7.3 1.9 2.1 5.7 5.3 9.5 6.3 3.7-4.4 3.3-9.3.5-13.6",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 47.4c2.7-9.8 13-22.8 34.4-22.4.9 0 1.6-.7 1.6-1.6v-6.8c0-.9-.7-1.6-1.6-1.6-14.8.1-38.8 2.6-46 31.6-.2 1 .6 2 1.6 2h8.4c.7 0 1.3-.5 1.5-1.2",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 97.2)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .9h118.6V43H0z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.2.9C1.9.9 0 2.5 0 6.7v17.4c0 2.5 1.3 4.5 5.2 4.5h5.6c2 0 3.3 1 3.3 4V39c0 1.8-.3 4.1 4 4.1h82.1c5 0 6.5.1 6.5-4.2V32c0-2.5.3-4.1 2.8-4.1h4c2 0 5.1-1 5.1-4.6V.9H47.8c-3.7 0-7.6.9-7.6 4.2v4.3c0 2-1.2 3.4-4.4 3.4h-8c-2 0-3.7-1.4-3.7-3.8V5C24 3 22.9 1 20.5 1H5.2z",
    fill: "#00D4B5",
    mask: "url(#account_privacy__b)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 130.4c1.7 0 10.2-17.8 15.9-22 5.7-4.1 15.9-7.9 15.9-10.3V80.8c0-3.3.1-6-3.7-6.9-3.8-1-5 5.3-14 5.3s-9.8-7.1-14-7.1c-3.7 0-.6 15.7-9.6 15.7S74.6 92 74.6 98v5.2c0 3 .1 6.7 5.8 10.9a709 709 0 0 0 20 14 12 12 0 0 0 6 2.2",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 72c-3.6 0-5.1 7.2-14.1 7.2S82.1 73 78.2 74c-3.8 1-3.6 3.6-3.6 6.9V98h31.7v-26zM132.2 114.2c5.7-4.2 5.9-7.9 5.9-10.9v-5.2h-31.8v32.3a12 12 0 0 0 6-2.3c2.1-1.4 14.2-9.7 20-14",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 126.7H38.3a1 1 0 1 1 0-2H71a1 1 0 1 1 0 2",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2 134.4a1 1 0 0 1-1-1v-7.7a1 1 0 1 1 2 0v7.7c0 .6-.5 1-1 1M62.8 126.7a1 1 0 0 1-1-1v-7.8a1 1 0 1 1 2 0v7.8c0 .5-.4 1-1 1",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.18828e34715ad007c774528628c90ef7.svg";
export { ForwardRef as ReactComponent };